@if (userData && userData.name) {
<section class="greeting container">
  {{ 'home.greeting' | translate : { field: userData.name | translate } }}
</section>
}
<section class="home-content">
  @if (privateContenData && privateContenData.length > 0) {
  <app-content [contenData]="privateContenData" [managView]="false"/>
}

@if (publicContenData && publicContenData.length > 0) {
  <app-content [contenData]="publicContenData" [managView]="false"/>
}

@if (publicContenData && publicContenData.length === 0 && privateContenData && privateContenData.length === 0) {
  <app-content [contenData]="[]" [managView]="false"/>
}
</section>
